import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';

export default function ButtonTip({ placement = 'top', title, children }) {
  return (
    <Tooltip title={title} arrow placement={placement} sx={{ color: 'red' }}>
      {children}
    </Tooltip>
  );
}
